import { useState } from "react";
import {
  Input,
  Select,
  Button,
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  HStack,
  useDisclosure,
  useToast,
  MenuItem,
} from "@chakra-ui/react";
import { editATax } from "../../../actions/management.action";

const EditTax = ({ data, id, reload }) => {
  const toast = useToast();
  const states = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
    "Andaman and Nicobar Islands",
    "Chandigarh",
    "Dadra and Nagar Haveli and Daman and Diu",
    "Delhi",
    "Jammu and Kashmir",
    "Ladakh",
    "Lakshadweep",
    "Puducherry",
  ];

  const [formData, setFormData] = useState(data);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!id || !formData) {
      return;
    }
    editATax(formData, id)
      .then(() => {
        toast({
          title: "Success",
          description: "New tax added",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        reload();
      })
      .catch((err) => {
        console.log(err);
        toast({
          title: "Error",
          description: err?.message || "Something went wrong",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      });
    onClose();
  };

  return (
    <>
      <HStack>
        <MenuItem
          _hover={{
            bg: "gray.100",
            color: "blue.500",
            cursor: "pointer",
          }}
          p={2}
          borderRadius={0}
          transition="background-color 0.2s ease"
          onClick={onOpen}
        >
          Edit Tax
        </MenuItem>
      </HStack>

      <AlertDialog
        motionPreset="slideInBottom"
        isOpen={isOpen}
        onClose={onClose}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent borderRadius={0} boxShadow="lg" margin={2}>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Edit Tax Details
            </AlertDialogHeader>

            <AlertDialogBody>
              <form onSubmit={handleSubmit}>
                <Select
                  name="state"
                  placeholder="Select State"
                  value={formData?.state}
                  onChange={handleChange}
                  mb={4}
                >
                  {states.map((state) => (
                    <option key={state} value={state}>
                      {state}
                    </option>
                  ))}
                </Select>
                <Input
                  name="tollTax"
                  placeholder="Toll Tax"
                  value={formData?.tollTax}
                  onChange={handleChange}
                  mb={4}
                />
                <Input
                  name="stateTax"
                  placeholder="State Tax"
                  value={formData?.stateTax}
                  onChange={handleChange}
                  mb={4}
                />
              </form>
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button
                onClick={onClose}
                variant="outline"
                mr={3}
                borderRadius={0}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                colorScheme="blue"
                onClick={handleSubmit}
                borderRadius={0}
              >
                Submit
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default EditTax;
